import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const MensagensService = {
  async getMensagens() {
    const response = await BaseService.fetchResponseFromAPIGet(`mensagemferias`);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.content;
  },
  async verificarMensagemChefeSeplanMilitaresSemAgendamento() {
    const response = await BaseService.fetchResponseFromAPIGet(`mensagemferias-militares-sem-agendar`);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.content;
  },
  async lerMenssagem(id) {
    const response = await BaseService.fetchResponseFromAPIDelete(`mensagemferias/lida/${id}`);
    if (response.error) {
      SnackBarModule(response.message, "error");
    }
    return response.content;
  }
  
}